const _tops = {
	'a-tee': {
		name: 'A tee',
		variations: {
			na: 'NA',
		},
	},
	'acid-washed-jacket': {
		name: 'acid-washed jacket',
		variations: {
			black: 'Black',
			blue: 'Blue',
		},
	},
	'after-school-jacket': {
		name: 'after-school jacket',
		variations: {
			black: 'Black',
			'berry-red': 'Berry red',
			green: 'Green',
			white: 'White',
			purple: 'Purple',
			gray: 'Gray',
			blue: 'Blue',
		},
	},
	'animal-print-coat': {
		name: 'animal-print coat',
		variations: {
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'animal-stripes-tee': {
		name: 'animal-stripes tee',
		variations: {
			tiger: 'Tiger',
			zebra: 'Zebra',
		},
	},
	'annyeong-tee': {
		name: 'annyeong tee',
		variations: {
			na: 'NA',
		},
	},
	'anorak-jacket': {
		name: 'anorak jacket',
		variations: {
			red: 'Red',
			blue: 'Blue',
			camel: 'Camel',
		},
	},
	apron: {
		name: 'apron',
		variations: {
			green: 'Green',
			blue: 'Blue',
			pink: 'Pink',
			'light-blue': 'Light blue',
			purple: 'Purple',
			orange: 'Orange',
			gray: 'Gray',
			brown: 'Brown',
		},
	},
	'aran-knit-cardigan': {
		name: 'Aran-knit cardigan',
		variations: {
			'light-blue': 'Light blue',
			pink: 'Pink',
			beige: 'Beige',
			yellow: 'Yellow',
		},
	},
	'aran-knit-sweater': {
		name: 'Aran-knit sweater',
		variations: {
			white: 'White',
			gray: 'Gray',
			green: 'Green',
			black: 'Black',
			orange: 'Orange',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'argyle-sweater': {
		name: 'argyle sweater',
		variations: {
			gray: 'Gray',
			mustard: 'Mustard',
			black: 'Black',
			red: 'Red',
			purple: 'Purple',
			pink: 'Pink',
			white: 'White',
			green: 'Green',
		},
	},
	'argyle-vest': {
		name: 'argyle vest',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			brown: 'Brown',
			red: 'Red',
			gray: 'Gray',
			green: 'Green',
		},
	},
	'athletic-jacket': {
		name: 'athletic jacket',
		variations: {
			green: 'Green',
			black: 'Black',
			red: 'Red',
			blue: 'Blue',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
		},
	},
	'baggy-shirt': {
		name: 'baggy shirt',
		variations: {
			black: 'Black',
			brown: 'Brown',
			gray: 'Gray',
		},
	},
	'baseball-shirt': {
		name: 'baseball shirt',
		variations: {
			red: 'Red',
			gray: 'Gray',
			black: 'Black',
			white: 'White',
			yellow: 'Yellow',
			'navy-blue': 'Navy blue',
		},
	},
	'basketball-tank': {
		name: 'basketball tank',
		variations: {
			purple: 'Purple',
			orange: 'Orange',
			blue: 'Blue',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			black: 'Black',
			red: 'Red',
			green: 'Green',
		},
	},
	'bear-tee': {
		name: 'bear tee',
		variations: {
			na: 'NA',
		},
	},
	'big-star-tee': {
		name: 'big-star tee',
		variations: {
			na: 'NA',
		},
	},
	'biker-jacket': {
		name: 'biker jacket',
		variations: {
			brown: 'Brown',
			beige: 'Beige',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'blossom-tee': {
		name: 'blossom tee',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'boa-blouson': {
		name: 'boa blouson',
		variations: {
			beige: 'Beige',
			blue: 'Blue',
			white: 'White',
			purple: 'Purple',
		},
	},
	'boa-fleece': {
		name: 'boa fleece',
		variations: {
			white: 'White',
			yellow: 'Yellow',
			lime: 'Lime',
			green: 'Green',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			blue: 'Blue',
			pink: 'Pink',
		},
	},
	'bold-aloha-shirt': {
		name: 'bold aloha shirt',
		variations: {
			'navy-blue': 'Navy blue',
			pink: 'Pink',
		},
	},
	'bomber-style-jacket': {
		name: 'bomber-style jacket',
		variations: {
			avocado: 'Avocado',
			black: 'Black',
			blue: 'Blue',
			brown: 'Brown',
		},
	},
	'bone-tee': {
		name: 'bone tee',
		variations: {
			na: 'NA',
		},
	},
	'bonjour-tee': {
		name: 'bonjour tee',
		variations: {
			na: 'NA',
		},
	},
	'botanical-tee': {
		name: 'botanical tee',
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'bowling-shirt': {
		name: 'bowling shirt',
		variations: {
			beige: 'Beige',
			green: 'Green',
			'light-blue': 'Light blue',
			purple: 'Purple',
			blue: 'Blue',
			yellow: 'Yellow',
			orange: 'Orange',
			red: 'Red',
		},
	},
	'bug-aloha-shirt': {
		name: 'bug aloha shirt',
		variations: {
			na: 'NA',
		},
	},
	'bulldog-jacket': {
		name: 'bulldog jacket',
		variations: {
			black: 'Black',
			white: 'White',
			red: 'Red',
		},
	},
	'business-suitcoat': {
		name: 'business suitcoat',
		variations: {
			blue: 'Blue',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			black: 'Black',
		},
	},
	'cafe-uniform': {
		name: 'café uniform',
		variations: {
			green: 'Green',
			red: 'Red',
			brown: 'Brown',
			black: 'Black',
		},
	},
	'camo-bomber-style-jacket': {
		name: 'camo bomber-style jacket',
		variations: {
			green: 'Green',
			gray: 'Gray',
			purple: 'Purple',
		},
	},
	'camo-tee': {
		name: 'camo tee',
		variations: {
			brown: 'Brown',
			avocado: 'Avocado',
			pink: 'Pink',
			gray: 'Gray',
			blue: 'Blue',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'camper-tee': {
		name: 'camper tee',
		variations: {
			na: 'NA',
		},
	},
	'cardigan-shirt-combo': {
		name: 'cardigan-shirt combo',
		variations: {
			yellow: 'Yellow',
			mint: 'Mint',
			pink: 'Pink',
			blue: 'Blue',
			gray: 'Gray',
			black: 'Black',
		},
	},
	'career-jacket': {
		name: 'career jacket',
		variations: {
			gray: 'Gray',
			beige: 'Beige',
			peach: 'Peach',
			'light-blue': 'Light blue',
			pink: 'Pink',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'cavalier-shirt': {
		name: 'cavalier shirt',
		variations: {
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'checkered-chesterfield-coat': {
		name: 'checkered chesterfield coat',
		variations: {
			brown: 'Brown',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'checkered-muffler': {
		name: 'checkered muffler',
		variations: {
			white: 'White',
			gray: 'Gray',
			brown: 'Brown',
			camel: 'Camel',
		},
	},
	'chefs-outfit': {
		name: "chef's outfit",
		variations: {
			red: 'Red',
			yellow: 'Yellow',
			orange: 'Orange',
			brown: 'Brown',
			black: 'Black',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'chesterfield-coat': {
		name: 'chesterfield coat',
		variations: {
			camel: 'Camel',
			brown: 'Brown',
			black: 'Black',
			gray: 'Gray',
		},
	},
	'chick-tee': {
		name: 'chick tee',
		variations: {
			na: 'NA',
		},
	},
	'chimayo-vest': {
		name: 'Chimayo vest',
		variations: {
			red: 'Red',
			white: 'White',
			'navy-blue': 'Navy blue',
			'light-blue': 'Light blue',
		},
	},
	'ciao-tee': {
		name: 'ciao tee',
		variations: {
			na: 'NA',
		},
	},
	coatigan: {
		name: 'coatigan',
		variations: {
			purple: 'Purple',
			pink: 'Pink',
			'light-blue': 'Light blue',
			gray: 'Gray',
			green: 'Green',
		},
	},
	'collarless-coat': {
		name: 'collarless coat',
		variations: {
			beige: 'Beige',
			pink: 'Pink',
			gray: 'Gray',
		},
	},
	'collarless-shirt': {
		name: 'collarless shirt',
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'college-cardigan': {
		name: 'college cardigan',
		variations: {
			'navy-blue': 'Navy blue',
			red: 'Red',
			gray: 'Gray',
			orange: 'Orange',
			white: 'White',
		},
	},
	'color-block-dress-shirt': {
		name: 'color-block dress shirt',
		variations: {
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			yellow: 'Yellow',
			gray: 'Gray',
			red: 'Red',
		},
	},
	'colorful-striped-sweater': {
		name: 'colorful striped sweater',
		variations: {
			'white-yellow-and-red': 'White, yellow & red',
			'black-coral-and-pink': 'Black, coral & pink',
			'orange-yellow-and-black': 'Orange, yellow & black',
			'gray-white-and-light-blue': 'Gray, white & light blue',
			'white-blue-and-green': 'White, blue & green',
			'navy-light-blue-and-pink': 'Navy, light blue & pink',
		},
	},
	'comedians-outfit': {
		name: "comedian's outfit",
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
			green: 'Green',
			purple: 'Purple',
			aquamarine: 'Aquamarine',
			white: 'White',
		},
	},
	'coverall-coat': {
		name: 'coverall coat',
		variations: {
			avocado: 'Avocado',
			red: 'Red',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
		},
	},
	'cowboy-shirt': {
		name: 'cowboy shirt',
		variations: {
			white: 'White',
			red: 'Red',
			blue: 'Blue',
			'light-blue': 'Light blue',
			brown: 'Brown',
		},
	},
	'cycling-shirt': {
		name: 'cycling shirt',
		variations: {
			'black-and-blue': 'Black & blue',
			'black-and-red': 'Black & red',
			'yellow-and-black': 'Yellow & black',
			'red-and-green': 'Red & green',
			'blue-and-white': 'Blue & white',
			'red-and-orange': 'Red & orange',
			'lime-and-light-blue': 'Lime & light blue',
			'purple-and-pink': 'Purple & pink',
		},
	},
	'dal-apron': {
		name: 'DAL apron',
		variations: {
			na: 'NA',
		},
	},
	'dal-pilot-jacket': {
		name: 'DAL pilot jacket',
		variations: {
			na: 'NA',
		},
	},
	'dal-tee': {
		name: 'DAL tee',
		variations: {
			na: 'NA',
		},
	},
	'dance-team-jacket': {
		name: 'dance-team jacket',
		variations: {
			white: 'White',
			purple: 'Purple',
			red: 'Red',
			black: 'Black',
		},
	},
	'danger-tank': {
		name: 'danger tank',
		variations: {
			na: 'NA',
		},
	},
	'denim-jacket': {
		name: 'denim jacket',
		variations: {
			'navy-blue': 'Navy blue',
			black: 'Black',
			white: 'White',
			'light-blue': 'Light blue',
			blue: 'Blue',
		},
	},
	'denim-vest': {
		name: 'denim vest',
		variations: {
			blue: 'Blue',
			'navy-blue': 'Navy blue',
			'washed-out': 'Washed out',
			black: 'Black',
			white: 'White',
		},
	},
	'detectives-coat': {
		name: "detective's coat",
		variations: {
			brown: 'Brown',
			gray: 'Gray',
			beige: 'Beige',
		},
	},
	'diner-apron': {
		name: 'diner apron',
		variations: {
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
			aquamarine: 'Aquamarine',
			pink: 'Pink',
			cream: 'Cream',
			black: 'Black',
		},
	},
	'doctors-coat': {
		name: "doctor's coat",
		variations: {
			'red-necktie': 'Red necktie',
			'black-necktie': 'Black necktie',
		},
	},
	'dolly-shirt': {
		name: 'dolly shirt',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			purple: 'Purple',
		},
	},
	'dotted-raincoat': {
		name: 'dotted raincoat',
		variations: {
			pink: 'Pink',
			green: 'Green',
			blue: 'Blue',
			turquoise: 'Turquoise',
			gray: 'Gray',
			'light-blue': 'Light blue',
		},
	},
	doublet: {
		name: 'doublet',
		variations: {
			blue: 'Blue',
			green: 'Green',
			red: 'Red',
			black: 'Black',
		},
	},
	'down-jacket': {
		name: 'down jacket',
		variations: {
			blue: 'Blue',
			white: 'White',
			green: 'Green',
			yellow: 'Yellow',
			orange: 'Orange',
			lime: 'Lime',
			black: 'Black',
			red: 'Red',
		},
	},
	'down-ski-jacket': {
		name: 'down ski jacket',
		variations: {
			'red-and-yellow': 'Red & yellow',
			'blue-and-green': 'Blue & green',
			'navy-and-blue': 'Navy & blue',
			'navy-and-red': 'Navy & red',
		},
	},
	'dragon-jacket': {
		name: 'dragon jacket',
		variations: {
			na: 'NA',
		},
	},
	'dreamy-sweater': {
		name: 'dreamy sweater',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'dress-shirt': {
		name: 'dress shirt',
		variations: {
			gray: 'Gray',
			mint: 'Mint',
			pink: 'Pink',
			white: 'White',
			blue: 'Blue',
		},
	},
	'earbuds-combo': {
		name: 'earbuds combo',
		variations: {
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			brown: 'Brown',
		},
	},
	'eight-ball-tee': {
		name: 'eight-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'emblem-blazer': {
		name: 'emblem blazer',
		variations: {
			beige: 'Beige',
			'berry-red': 'Berry red',
			'navy-blue': 'Navy blue',
			green: 'Green',
		},
	},
	'embroidered-tank': {
		name: 'embroidered tank',
		variations: {
			red: 'Red',
			purple: 'Purple',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
			beige: 'Beige',
			'navy-blue': 'Navy blue',
		},
	},
	'energetic-sweater': {
		name: 'energetic sweater',
		variations: {
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'explorer-tee': {
		name: 'explorer tee',
		variations: {
			avocado: 'Avocado',
			beige: 'Beige',
			blue: 'Blue',
			camel: 'Camel',
		},
	},
	'faux-hair-sweater': {
		name: 'faux-hair sweater',
		variations: {
			white: 'White',
			red: 'Red',
		},
	},
	'faux-shearling-coat': {
		name: 'faux-shearling coat',
		variations: {
			green: 'Green',
			black: 'Black',
			gray: 'Gray',
			beige: 'Beige',
			pink: 'Pink',
		},
	},
	fischerhemd: {
		name: 'fischerhemd',
		variations: {
			na: 'NA',
		},
	},
	'fish-print-tee': {
		name: 'fish-print tee',
		variations: {
			na: 'NA',
		},
	},
	'fishing-vest': {
		name: 'fishing vest',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			purple: 'Purple',
			red: 'Red',
			black: 'Black',
			pink: 'Pink',
			green: 'Green',
			avocado: 'Avocado',
		},
	},
	'fitness-tank': {
		name: 'fitness tank',
		variations: {
			mint: 'Mint',
			red: 'Red',
			purple: 'Purple',
			pink: 'Pink',
			'light-blue': 'Light blue',
			orange: 'Orange',
			black: 'Black',
			yellow: 'Yellow',
		},
	},
	'five-ball-tee': {
		name: 'five-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'flame-tee': {
		name: 'flame tee',
		variations: {
			na: 'NA',
		},
	},
	'flannel-shirt': {
		name: 'flannel shirt',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			beige: 'Beige',
			purple: 'Purple',
		},
	},
	'flashy-cardigan': {
		name: 'flashy cardigan',
		variations: {
			blue: 'Blue',
			red: 'Red',
		},
	},
	'flashy-jacket': {
		name: 'flashy jacket',
		variations: {
			black: 'Black',
			purple: 'Purple',
			'berry-red': 'Berry red',
			aquamarine: 'Aquamarine',
			yellow: 'Yellow',
			white: 'White',
		},
	},
	'flight-jacket': {
		name: 'flight jacket',
		variations: {
			brown: 'Brown',
			black: 'Black',
			avocado: 'Avocado',
		},
	},
	'flower-sweater': {
		name: 'flower sweater',
		variations: {
			green: 'Green',
			white: 'White',
			yellow: 'Yellow',
			red: 'Red',
		},
	},
	'folk-shirt': {
		name: 'folk shirt',
		variations: {
			brown: 'Brown',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'football-shirt': {
		name: 'football shirt',
		variations: {
			green: 'Green',
			white: 'White',
			yellow: 'Yellow',
			'berry-red': 'Berry red',
			blue: 'Blue',
			turquoise: 'Turquoise',
			red: 'Red',
			black: 'Black',
		},
	},
	'four-ball-tee': {
		name: 'four-ball tee',
		variations: {
			purple: 'Purple',
		},
	},
	'frog-tee': {
		name: 'frog tee',
		variations: {
			na: 'NA',
		},
	},
	'front-tie-button-down-shirt': {
		name: 'front-tie button-down shirt',
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			gray: 'Gray',
			blue: 'Blue',
		},
	},
	'front-tie-tee': {
		name: 'front-tie tee',
		variations: {
			black: 'Black',
			white: 'White',
			red: 'Red',
			lime: 'Lime',
		},
	},
	'fuzzy-vest': {
		name: 'fuzzy vest',
		variations: {
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			brown: 'Brown',
			green: 'Green',
			red: 'Red',
		},
	},
	'garden-tank': {
		name: 'garden tank',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
		},
	},
	'gilet-and-shirt': {
		name: 'gilet and shirt',
		variations: {
			blue: 'Blue',
			red: 'Red',
			gray: 'Gray',
			black: 'Black',
		},
	},
	'gingham-picnic-shirt': {
		name: 'gingham picnic shirt',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
			orange: 'Orange',
			pink: 'Pink',
			purple: 'Purple',
			'light-blue': 'Light blue',
		},
	},
	'gold-print-tee': {
		name: 'gold-print tee',
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'gown-coat': {
		name: 'gown coat',
		variations: {
			black: 'Black',
			blue: 'Blue',
			red: 'Red',
			brown: 'Brown',
		},
	},
	'graduation-gown': {
		name: 'graduation gown',
		variations: {
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			red: 'Red',
		},
	},
	'groovy-shirt': {
		name: 'groovy shirt',
		variations: {
			orange: 'Orange',
			green: 'Green',
			red: 'Red',
		},
	},
	'groovy-tunic': {
		name: 'groovy tunic',
		variations: {
			orange: 'Orange',
			camel: 'Camel',
			brown: 'Brown',
		},
	},
	'guayabera-shirt': {
		name: 'guayabera shirt',
		variations: {
			red: 'Red',
			brown: 'Brown',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'guide-shirt': {
		name: 'guide shirt',
		variations: {
			green: 'Green',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'gym-tee': {
		name: 'gym tee',
		variations: {
			blue: 'Blue',
			green: 'Green',
			black: 'Black',
			red: 'Red',
		},
	},
	'hallo-tee': {
		name: 'hallo tee',
		variations: {
			na: 'NA',
		},
	},
	'hand-knit-tank': {
		name: 'hand-knit tank',
		variations: {
			black: 'Black',
			blue: 'Blue',
			green: 'Green',
			red: 'Red',
			camel: 'Camel',
			white: 'White',
		},
	},
	'hanten-jacket': {
		name: 'hanten jacket',
		variations: {
			'dark-blue': 'Dark blue',
			green: 'Green',
			brown: 'Brown',
			purple: 'Purple',
		},
	},
	'happi-tee': {
		name: 'happi tee',
		variations: {
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'hawk-jacket': {
		name: 'hawk jacket',
		variations: {
			na: 'NA',
		},
	},
	'heart-apron': {
		name: 'heart apron',
		variations: {
			blue: 'Blue',
			red: 'Red',
			purple: 'Purple',
			green: 'Green',
			pink: 'Pink',
		},
	},
	'heart-sweater': {
		name: 'heart sweater',
		variations: {
			red: 'Red',
			pink: 'Pink',
		},
	},
	'heavy-duty-shirt': {
		name: 'heavy-duty shirt',
		variations: {
			ochre: 'Ochre',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'hello-tee': {
		name: 'hello tee',
		variations: {
			na: 'NA',
		},
	},
	'henley-shirt': {
		name: 'henley shirt',
		variations: {
			mustard: 'Mustard',
			'light-blue': 'Light blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	'hi-tee': {
		name: 'hi tee',
		variations: {
			na: 'NA',
		},
	},
	'hip-wrap-shirt': {
		name: 'hip-wrap shirt',
		variations: {
			yellow: 'Yellow',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'hoi-tee': {
		name: 'hoi tee',
		variations: {
			na: 'NA',
		},
	},
	'hola-tee': {
		name: 'hola tee',
		variations: {
			na: 'NA',
		},
	},
	'holiday-sweater': {
		name: 'holiday sweater',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'hula-top': {
		name: 'hula top',
		variations: {
			orange: 'Orange',
			beige: 'Beige',
			purple: 'Purple',
			green: 'Green',
			red: 'Red',
		},
	},
	'humble-sweater': {
		name: 'humble sweater',
		variations: {
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			brown: 'Brown',
		},
	},
	'kanji-tee': {
		name: 'kanji tee',
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			black: 'Black',
			green: 'Green',
		},
	},
	'kids-smock': {
		name: "kids' smock",
		variations: {
			tulip: 'Tulip',
			chick: 'Chick',
			'cherry-blossom': 'Cherry blossom',
			frog: 'Frog',
		},
	},
	'konnichiwa-tee': {
		name: 'konnichiwa tee',
		variations: {
			na: 'NA',
		},
	},
	'kung-fu-tee': {
		name: 'kung-fu tee',
		variations: {
			'navy-blue': 'Navy blue',
			white: 'White',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			green: 'Green',
		},
	},
	kurta: {
		name: 'kurta',
		variations: {
			gray: 'Gray',
			blue: 'Blue',
			beige: 'Beige',
			green: 'Green',
		},
	},
	'labelle-coat': {
		name: 'Labelle coat',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'labelle-knit-shirt': {
		name: 'Labelle knit shirt',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'lacy-shirt': {
		name: 'lacy shirt',
		variations: {
			beige: 'Beige',
			black: 'Black',
		},
	},
	'lacy-tank': {
		name: 'lacy tank',
		variations: {
			green: 'Green',
			purple: 'Purple',
			white: 'White',
			pink: 'Pink',
			yellow: 'Yellow',
		},
	},
	'layered-shirt': {
		name: 'layered shirt',
		variations: {
			green: 'Green',
			orange: 'Orange',
			white: 'White',
			'navy-blue': 'Navy blue',
		},
	},
	'layered-tank': {
		name: 'layered tank',
		variations: {
			blue: 'Blue',
			green: 'Green',
			'light-blue': 'Light blue',
			red: 'Red',
			purple: 'Purple',
			yellow: 'Yellow',
			pink: 'Pink',
			orange: 'Orange',
		},
	},
	'leopard-tee': {
		name: 'leopard tee',
		variations: {
			pink: 'Pink',
			green: 'Green',
			gray: 'Gray',
			yellow: 'Yellow',
		},
	},
	'letter-jacket': {
		name: 'letter jacket',
		variations: {
			red: 'Red',
			green: 'Green',
			beige: 'Beige',
			blue: 'Blue',
		},
	},
	'madras-plaid-shirt': {
		name: 'madras plaid shirt',
		variations: {
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
			purple: 'Purple',
			pink: 'Pink',
			gray: 'Gray',
		},
	},
	'marble-dots-tee': {
		name: 'marble-dots tee',
		variations: {
			black: 'Black',
			white: 'White',
		},
	},
	'meme-shirt': {
		name: 'meme shirt',
		variations: {
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'military-uniform': {
		name: 'military uniform',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			white: 'White',
		},
	},
	'misty-tee': {
		name: 'misty tee',
		variations: {
			na: 'NA',
		},
	},
	'mod-parka': {
		name: 'mod parka',
		variations: {
			brown: 'Brown',
			green: 'Green',
		},
	},
	'moms-hand-knit-sweater': {
		name: "Mom's hand-knit sweater",
		variations: {
			flowers: 'Flowers',
			star: 'Star',
			animal: 'Animal',
			'teddy-bear': 'Teddy bear',
			m: 'M',
			'accent-patch': 'Accent patch',
			'quilted-pattern': 'Quilted pattern',
			chicks: 'Chicks',
		},
	},
	'moms-handmade-apron': {
		name: "Mom's handmade apron",
		variations: {
			'forest-print': 'Forest print',
			m: 'M',
			animals: 'Animals',
			family: 'Family',
			flowers: 'Flowers',
			'quilted-pattern': 'Quilted pattern',
			fruits: 'Fruits',
			denim: 'Denim',
		},
	},
	'morning-coat': {
		name: 'morning coat',
		variations: {
			na: 'NA',
		},
	},
	'mountain-parka': {
		name: 'mountain parka',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			black: 'Black',
		},
	},
	'multipurpose-vest': {
		name: 'multipurpose vest',
		variations: {
			gray: 'Gray',
			avocado: 'Avocado',
			beige: 'Beige',
		},
	},
	'muscle-tank': {
		name: 'muscle tank',
		variations: {
			yellow: 'Yellow',
			purple: 'Purple',
			pink: 'Pink',
			black: 'Black',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'music-fest-shirt': {
		name: 'music-fest shirt',
		variations: {
			red: 'Red',
			purple: 'Purple',
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	'mvp-tee': {
		name: 'MVP tee',
		variations: {
			na: 'NA',
		},
	},
	'ni-hao-tee': {
		name: 'ni hao tee',
		variations: {
			na: 'NA',
		},
	},
	'nine-ball-tee': {
		name: 'nine-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'no-1-shirt': {
		name: 'No. 1 shirt',
		variations: {
			na: 'NA',
		},
	},
	'no-2-shirt': {
		name: 'No. 2 shirt',
		variations: {
			na: 'NA',
		},
	},
	'no-3-shirt': {
		name: 'No. 3 shirt',
		variations: {
			na: 'NA',
		},
	},
	'no-4-shirt': {
		name: 'No. 4 shirt',
		variations: {
			na: 'NA',
		},
	},
	'noble-coat': {
		name: 'noble coat',
		variations: {
			white: 'White',
			blue: 'Blue',
			black: 'Black',
			purple: 'Purple',
			yellow: 'Yellow',
			red: 'Red',
			green: 'Green',
			'ruby-red': 'Ruby red',
		},
	},
	'nook-inc-aloha-shirt': {
		name: 'Nook Inc. aloha shirt',
		variations: {
			na: 'NA',
		},
	},
	'nook-inc-blouson': {
		name: 'Nook Inc. blouson',
		variations: {
			na: 'NA',
		},
	},
	'nook-inc-tee': {
		name: 'Nook Inc. tee',
		variations: {
			na: 'NA',
		},
	},
	'nurses-jacket': {
		name: "nurse's jacket",
		variations: {
			white: 'White',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'nylon-jacket': {
		name: 'nylon jacket',
		variations: {
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
			red: 'Red',
		},
	},
	'oilskin-coat': {
		name: 'oilskin coat',
		variations: {
			red: 'Red',
			gray: 'Gray',
			yellow: 'Yellow',
		},
	},
	'ok-motors-jacket': {
		name: 'OK Motors jacket',
		variations: {
			na: 'NA',
		},
	},
	'old-school-jacket': {
		name: 'old-school jacket',
		variations: {
			green: 'Green',
			red: 'Red',
			purple: 'Purple',
		},
	},
	'one-ball-tee': {
		name: 'one-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'open-collar-shirt': {
		name: 'open-collar shirt',
		variations: {
			coral: 'Coral',
			blue: 'Blue',
			green: 'Green',
			beige: 'Beige',
		},
	},
	'oversized-shawl-overshirt': {
		name: 'oversized shawl overshirt',
		variations: {
			pink: 'Pink',
			gray: 'Gray',
			brown: 'Brown',
		},
	},
	'parka-undercoat': {
		name: 'parka undercoat',
		variations: {
			'navy-blue': 'Navy blue',
			blue: 'Blue',
			black: 'Black',
			green: 'Green',
			gray: 'Gray',
			yellow: 'Yellow',
		},
	},
	'patchwork-coat': {
		name: 'patchwork coat',
		variations: {
			brown: 'Brown',
			green: 'Green',
			gray: 'Gray',
		},
	},
	peacoat: {
		name: 'peacoat',
		variations: {
			red: 'Red',
			beige: 'Beige',
			gray: 'Gray',
			'navy-blue': 'Navy blue',
		},
	},
	'peasant-blouse': {
		name: 'peasant blouse',
		variations: {
			black: 'Black',
			beige: 'Beige',
			pink: 'Pink',
			purple: 'Purple',
			white: 'White',
		},
	},
	'pineapple-aloha-shirt': {
		name: 'pineapple aloha shirt',
		variations: {
			orange: 'Orange',
			red: 'Red',
			yellow: 'Yellow',
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'plaid-puffed-sleeve-shirt': {
		name: 'plaid puffed-sleeve shirt',
		variations: {
			'fancy-plaid': 'Fancy plaid',
			'energetic-plaid': 'Energetic plaid',
			'dreamy-plaid': 'Dreamy plaid',
			'sweet-plaid': 'Sweet plaid',
		},
	},
	'pleather-trench-coat': {
		name: 'pleather trench coat',
		variations: {
			purple: 'Purple',
			brown: 'Brown',
			black: 'Black',
		},
	},
	'plover-cardigan': {
		name: 'plover cardigan',
		variations: {
			black: 'Black',
			green: 'Green',
			red: 'Red',
		},
	},
	'plushie-muffler-coat': {
		name: 'plushie-muffler coat',
		variations: {
			gray: 'Gray',
			orange: 'Orange',
			pink: 'Pink',
		},
	},
	'pocket-tee': {
		name: 'pocket tee',
		variations: {
			black: 'Black',
			purple: 'Purple',
			'light-blue': 'Light blue',
			red: 'Red',
			yellow: 'Yellow',
			pink: 'Pink',
			green: 'Green',
			white: 'White',
		},
	},
	'polo-shirt': {
		name: 'polo shirt',
		variations: {
			pink: 'Pink',
			red: 'Red',
			orange: 'Orange',
			'navy-blue': 'Navy blue',
			green: 'Green',
			ivory: 'Ivory',
			white: 'White',
			black: 'Black',
		},
	},
	'pom-pom-sweater': {
		name: 'pom-pom sweater',
		variations: {
			white: 'White',
			blue: 'Blue',
			pink: 'Pink',
		},
	},
	'poncho-coat': {
		name: 'poncho coat',
		variations: {
			red: 'Red',
			yellow: 'Yellow',
			pink: 'Pink',
			'navy-blue': 'Navy blue',
		},
	},
	'poncho-style-sweater': {
		name: 'poncho-style sweater',
		variations: {
			purple: 'Purple',
			'peacock-blue': 'Peacock blue',
			orange: 'Orange',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'princes-tunic': {
		name: "prince's tunic",
		variations: {
			blue: 'Blue',
			beige: 'Beige',
			green: 'Green',
			red: 'Red',
			purple: 'Purple',
		},
	},
	'printed-fleece-sweater': {
		name: 'printed fleece sweater',
		variations: {
			blue: 'Blue',
			brown: 'Brown',
			purple: 'Purple',
			green: 'Green',
			'moss-green': 'Moss green',
		},
	},
	'printed-layered-shirt': {
		name: 'printed layered shirt',
		variations: {
			yellow: 'Yellow',
			white: 'White',
			black: 'Black',
		},
	},
	'printed-sleeve-sweater': {
		name: 'printed-sleeve sweater',
		variations: {
			orange: 'Orange',
			white: 'White',
			black: 'Black',
		},
	},
	'privet-tee': {
		name: 'privét tee',
		variations: {
			na: 'NA',
		},
	},
	'puffy-vest': {
		name: 'puffy vest',
		variations: {
			camel: 'Camel',
			blue: 'Blue',
			olive: 'Olive',
			'navy-blue': 'Navy blue',
			red: 'Red',
		},
	},
	'puffy-sleeve-blouse': {
		name: 'puffy-sleeve blouse',
		variations: {
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			pink: 'Pink',
			lime: 'Lime',
		},
	},
	'pullover-jacket': {
		name: 'pullover jacket',
		variations: {
			red: 'Red',
			'light-blue': 'Light blue',
			'navy-blue': 'Navy blue',
			purple: 'Purple',
			coral: 'Coral',
		},
	},
	'quilted-down-jacket': {
		name: 'quilted down jacket',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			green: 'Green',
			purple: 'Purple',
			olive: 'Olive',
		},
	},
	'quilted-jacket': {
		name: 'quilted jacket',
		variations: {
			lime: 'Lime',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
			brown: 'Brown',
		},
	},
	'rabbit-tee': {
		name: 'rabbit tee',
		variations: {
			na: 'NA',
		},
	},
	'raglan-tee': {
		name: 'raglan tee',
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
			white: 'White',
		},
	},
	'rainbow-sweater': {
		name: 'rainbow sweater',
		variations: {
			white: 'White',
			red: 'Red',
			green: 'Green',
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	raincoat: {
		name: 'raincoat',
		variations: {
			yellow: 'Yellow',
			purple: 'Purple',
			pink: 'Pink',
			red: 'Red',
			beige: 'Beige',
			black: 'Black',
			green: 'Green',
			blue: 'Blue',
		},
	},
	'reindeer-sweater': {
		name: 'reindeer sweater',
		variations: {
			green: 'Green',
			brown: 'Brown',
			red: 'Red',
		},
	},
	'relay-tank': {
		name: 'relay tank',
		variations: {
			'light-blue': 'Light blue',
			purple: 'Purple',
			black: 'Black',
			orange: 'Orange',
			green: 'Green',
			red: 'Red',
			white: 'White',
			blue: 'Blue',
		},
	},
	'retro-coat': {
		name: 'retro coat',
		variations: {
			mustard: 'Mustard',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
		},
	},
	'retro-sweater': {
		name: 'retro sweater',
		variations: {
			yellow: 'Yellow',
			white: 'White',
			blue: 'Blue',
			purple: 'Purple',
		},
	},
	'ribbon-straps-tank': {
		name: 'ribbon-straps tank',
		variations: {
			black: 'Black',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'royal-shirt': {
		name: 'royal shirt',
		variations: {
			na: 'NA',
		},
	},
	'rubber-apron': {
		name: 'rubber apron',
		variations: {
			black: 'Black',
			white: 'White',
		},
	},
	'safety-vest': {
		name: 'safety vest',
		variations: {
			black: 'Black',
			orange: 'Orange',
		},
	},
	'sailor-style-shirt': {
		name: 'sailor-style shirt',
		variations: {
			'navy-blue': 'Navy blue',
			'light-blue': 'Light blue',
			white: 'White',
		},
	},
	'sailors-tee': {
		name: "sailor's tee",
		variations: {
			'navy-blue': 'Navy blue',
			orange: 'Orange',
			'light-blue': 'Light blue',
			green: 'Green',
			brown: 'Brown',
			purple: 'Purple',
			red: 'Red',
			pink: 'Pink',
		},
	},
	'samurai-shirt': {
		name: 'samurai shirt',
		variations: {
			black: 'Black',
			blue: 'Blue',
			white: 'White',
			'golden-yellow': 'Golden yellow',
			red: 'Red',
		},
	},
	'school-jacket': {
		name: 'school jacket',
		variations: {
			white: 'White',
			black: 'Black',
			purple: 'Purple',
			gray: 'Gray',
			blue: 'Blue',
			'berry-red': 'Berry red',
			green: 'Green',
		},
	},
	'sea-hanten-shirt': {
		name: 'sea hanten shirt',
		variations: {
			'dark-blue': 'Dark blue',
			blue: 'Blue',
		},
	},
	'seven-ball-tee': {
		name: 'seven-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'shirt-with-camera': {
		name: 'shirt with camera',
		variations: {
			'light-blue': 'Light blue',
			black: 'Black',
		},
	},
	'short-peacoat': {
		name: 'short peacoat',
		variations: {
			black: 'Black',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			orange: 'Orange',
			green: 'Green',
			gray: 'Gray',
			pink: 'Pink',
		},
	},
	'short-sleeve-dress-shirt': {
		name: 'short-sleeve dress shirt',
		variations: {
			red: 'Red',
			green: 'Green',
			yellow: 'Yellow',
			blue: 'Blue',
			white: 'White',
		},
	},
	'silk-floral-print-shirt': {
		name: 'silk floral-print shirt',
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			mustard: 'Mustard',
			gray: 'Gray',
			purple: 'Purple',
			green: 'Green',
			pink: 'Pink',
		},
	},
	'silk-shirt': {
		name: 'silk shirt',
		variations: {
			green: 'Green',
			black: 'Black',
			red: 'Red',
			blue: 'Blue',
			yellow: 'Yellow',
		},
	},
	'simple-knit-sweater': {
		name: 'simple knit sweater',
		variations: {
			white: 'White',
			camel: 'Camel',
			black: 'Black',
		},
	},
	'simple-parka': {
		name: 'simple parka',
		variations: {
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
			'light-blue': 'Light blue',
			black: 'Black',
			gray: 'Gray',
			red: 'Red',
		},
	},
	'simple-dots-tee': {
		name: 'simple-dots tee',
		variations: {
			'light-blue': 'Light blue',
			red: 'Red',
			green: 'Green',
			black: 'Black',
			yellow: 'Yellow',
		},
	},
	'six-ball-tee': {
		name: 'six-ball tee',
		variations: {
			na: 'NA',
		},
	},
	skiwear: {
		name: 'skiwear',
		variations: {
			'light-blue': 'Light blue',
			purple: 'Purple',
			green: 'Green',
			red: 'Red',
			'ruby-red': 'Ruby red',
			blue: 'Blue',
		},
	},
	'skull-tee': {
		name: 'skull tee',
		variations: {
			black: 'Black',
			beige: 'Beige',
			purple: 'Purple',
		},
	},
	'sleeved-apron': {
		name: 'sleeved apron',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	'sleeveless-dress-shirt': {
		name: 'sleeveless dress shirt',
		variations: {
			white: 'White',
			pink: 'Pink',
			green: 'Green',
			orange: 'Orange',
			blue: 'Blue',
		},
	},
	'sleeveless-parka': {
		name: 'sleeveless parka',
		variations: {
			green: 'Green',
			black: 'Black',
			pink: 'Pink',
			purple: 'Purple',
			orange: 'Orange',
		},
	},
	'sleeveless-tunic': {
		name: 'sleeveless tunic',
		variations: {
			mint: 'Mint',
			pink: 'Pink',
			white: 'White',
			yellow: 'Yellow',
			blue: 'Blue',
			purple: 'Purple',
		},
	},
	'snowflake-sweater': {
		name: 'snowflake sweater',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
		},
	},
	'snowy-sweater': {
		name: 'snowy sweater',
		variations: {
			blue: 'Blue',
			black: 'Black',
			gray: 'Gray',
		},
	},
	'soccer-uniform-top': {
		name: 'soccer-uniform top',
		variations: {
			black: 'Black',
			yellow: 'Yellow',
			red: 'Red',
			blue: 'Blue',
			'light-blue': 'Light blue',
			green: 'Green',
			orange: 'Orange',
			white: 'White',
		},
	},
	'space-parka': {
		name: 'space parka',
		variations: {
			blue: 'Blue',
			purple: 'Purple',
		},
	},
	'sparkly-embroidered-tank': {
		name: 'sparkly embroidered tank',
		variations: {
			red: 'Red',
			yellow: 'Yellow',
			blue: 'Blue',
		},
	},
	'spider-web-tee': {
		name: 'spider-web tee',
		variations: {
			na: 'NA',
		},
	},
	'sports-tank': {
		name: 'sports tank',
		variations: {
			1: '1',
			2: '2',
			3: '3',
			4: '4',
			5: '5',
			6: '6',
			7: '7',
			8: '8',
		},
	},
	'staff-uniform': {
		name: 'staff uniform',
		variations: {
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
		},
	},
	'starry-tank': {
		name: 'starry tank',
		variations: {
			na: 'NA',
		},
	},
	'striped-shirt': {
		name: 'striped shirt',
		variations: {
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			yellow: 'Yellow',
			purple: 'Purple',
			'navy-blue': 'Navy blue',
		},
	},
	'striped-tank': {
		name: 'striped tank',
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			yellow: 'Yellow',
			red: 'Red',
			gray: 'Gray',
			black: 'Black',
			pink: 'Pink',
			green: 'Green',
		},
	},
	'striped-tee': {
		name: 'striped tee',
		variations: {
			purple: 'Purple',
			white: 'White',
			red: 'Red',
			camel: 'Camel',
			green: 'Green',
			'navy-blue': 'Navy blue',
		},
	},
	'sushi-chefs-outfit': {
		name: "sushi chef's outfit",
		variations: {
			'dark-blue': 'Dark blue',
			white: 'White',
		},
	},
	'sweater-on-shirt': {
		name: 'sweater on shirt',
		variations: {
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			gray: 'Gray',
			pink: 'Pink',
		},
	},
	'sweater-vest': {
		name: 'sweater-vest',
		variations: {
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			white: 'White',
			beige: 'Beige',
		},
	},
	sweatshirt: {
		name: 'sweatshirt',
		variations: {
			gray: 'Gray',
			blue: 'Blue',
			green: 'Green',
			yellow: 'Yellow',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'sweetheart-tank-and-shirt': {
		name: 'sweetheart tank and shirt',
		variations: {
			gray: 'Gray',
			beige: 'Beige',
			green: 'Green',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	tailcoat: {
		name: 'tailcoat',
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'tailored-jacket': {
		name: 'tailored jacket',
		variations: {
			black: 'Black',
			'navy-blue': 'Navy blue',
			gray: 'Gray',
			beige: 'Beige',
			green: 'Green',
		},
	},
	tank: {
		name: 'tank',
		variations: {
			white: 'White',
			brown: 'Brown',
			red: 'Red',
			'navy-blue': 'Navy blue',
			black: 'Black',
		},
	},
	'tee-parka-combo': {
		name: 'tee-parka combo',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			pink: 'Pink',
			mint: 'Mint',
			lime: 'Lime',
		},
	},
	'tennis-sweater': {
		name: 'tennis sweater',
		variations: {
			ivory: 'Ivory',
			green: 'Green',
			brown: 'Brown',
			red: 'Red',
		},
	},
	'terry-cloth-nightgown': {
		name: 'terry-cloth nightgown',
		variations: {
			blue: 'Blue',
			green: 'Green',
			orange: 'Orange',
			purple: 'Purple',
			lime: 'Lime',
			pink: 'Pink',
			cream: 'Cream',
			'light-blue': 'Light blue',
		},
	},
	'text-shirt': {
		name: 'text shirt',
		variations: {
			black: 'Black',
			white: 'White',
			red: 'Red',
		},
	},
	'thick-stripes-shirt': {
		name: 'thick-stripes shirt',
		variations: {
			'green-and-navy': 'Green & navy',
			'rose-red-and-navy': 'Rose red & navy',
			'beige-and-navy': 'Beige & navy',
			'green-and-purple': 'Green & purple',
			'yellow-and-red': 'Yellow & red',
			'navy-and-gray': 'Navy & gray',
			'light-blue-and-black': 'Light blue & black',
			'yellow-and-navy': 'Yellow & navy',
		},
	},
	'thiefs-costume': {
		name: "thief's costume",
		variations: {
			na: 'NA',
		},
	},
	'thread-worn-sweater': {
		name: 'thread-worn sweater',
		variations: {
			green: 'Green',
			black: 'Black',
			beige: 'Beige',
			pink: 'Pink',
		},
	},
	'three-ball-tee': {
		name: 'three-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'tie-dye-shirt': {
		name: 'tie-dye shirt',
		variations: {
			na: 'NA',
		},
	},
	'tiger-jacket': {
		name: 'tiger jacket',
		variations: {
			na: 'NA',
		},
	},
	'tight-knit-sweater': {
		name: 'tight-knit sweater',
		variations: {
			black: 'Black',
			beige: 'Beige',
			gray: 'Gray',
		},
	},
	'top-coat': {
		name: 'top coat',
		variations: {
			beige: 'Beige',
			brown: 'Brown',
			pink: 'Pink',
			'light-blue': 'Light blue',
		},
	},
	'track-jacket': {
		name: 'track jacket',
		variations: {
			gray: 'Gray',
			white: 'White',
			red: 'Red',
			'light-blue': 'Light blue',
			green: 'Green',
			blue: 'Blue',
			'navy-blue': 'Navy blue',
		},
	},
	'traditional-straw-coat': {
		name: 'traditional straw coat',
		variations: {
			na: 'NA',
		},
	},
	'tree-sweater': {
		name: 'tree sweater',
		variations: {
			na: 'NA',
		},
	},
	'trench-coat': {
		name: 'trench coat',
		variations: {
			'light-blue': 'Light blue',
			red: 'Red',
			orange: 'Orange',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
		},
	},
	'tube-top': {
		name: 'tube top',
		variations: {
			red: 'Red',
			yellow: 'Yellow',
			'dark-gray': 'Dark gray',
			purple: 'Purple',
			green: 'Green',
			blue: 'Blue',
			'dark-red': 'Dark red',
		},
	},
	'tunic-tank': {
		name: 'tunic tank',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			mint: 'Mint',
			white: 'White',
		},
	},
	'tuxedo-jacket': {
		name: 'tuxedo jacket',
		variations: {
			gray: 'Gray',
			white: 'White',
			black: 'Black',
		},
	},
	'tweed-jacket': {
		name: 'tweed jacket',
		variations: {
			blue: 'Blue',
			beige: 'Beige',
			'berry-red': 'Berry red',
			green: 'Green',
			pink: 'Pink',
			brown: 'Brown',
		},
	},
	'tweed-vest': {
		name: 'tweed vest',
		variations: {
			red: 'Red',
			'navy-blue': 'Navy blue',
			green: 'Green',
		},
	},
	'two-ball-tee': {
		name: 'two-ball tee',
		variations: {
			na: 'NA',
		},
	},
	'v-neck-sweater': {
		name: 'V-neck sweater',
		variations: {
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
		},
	},
	'vampire-costume': {
		name: 'vampire costume',
		variations: {
			black: 'Black',
			purple: 'Purple',
		},
	},
	'vertical-stripes-shirt': {
		name: 'vertical-stripes shirt',
		variations: {
			blue: 'Blue',
			beige: 'Beige',
			orange: 'Orange',
			purple: 'Purple',
			pink: 'Pink',
			green: 'Green',
			gray: 'Gray',
		},
	},
	'vest-with-binoculars': {
		name: 'vest with binoculars',
		variations: {
			na: 'NA',
		},
	},
	'viking-top': {
		name: 'viking top',
		variations: {
			gray: 'Gray',
			blue: 'Blue',
			brown: 'Brown',
		},
	},
	waistcoat: {
		name: 'waistcoat',
		variations: {
			black: 'Black',
			beige: 'Beige',
			white: 'White',
			'navy-blue': 'Navy blue',
			gray: 'Gray',
		},
	},
	'western-shirt': {
		name: 'western shirt',
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			yellow: 'Yellow',
			black: 'Black',
		},
	},
	'work-apron': {
		name: 'work apron',
		variations: {
			avocado: 'Avocado',
			orange: 'Orange',
		},
	},
	'work-shirt': {
		name: 'work shirt',
		variations: {
			'red-striped-necktie': 'Red-striped necktie',
			'blue-striped-necktie': 'Blue-striped necktie',
			'purple-striped-necktie': 'Purple-striped necktie',
			'green-striped-necktie': 'Green-striped necktie',
			'white-striped-necktie': 'White-striped necktie',
		},
	},
	'workers-jacket': {
		name: "worker's jacket",
		variations: {
			'light-blue': 'Light blue',
			beige: 'Beige',
			'navy-blue': 'Navy blue',
		},
	},
	'workout-top': {
		name: 'workout top',
		variations: {
			orange: 'Orange',
			lime: 'Lime',
			pink: 'Pink',
		},
	},
	'yodel-cardigan': {
		name: 'yodel cardigan',
		variations: {
			beige: 'Beige',
			mustard: 'Mustard',
			mint: 'Mint',
			red: 'Red',
			'navy-blue': 'Navy blue',
			'ice-blue': 'Ice blue',
		},
	},
	'yodel-sweater': {
		name: 'yodel sweater',
		variations: {
			camel: 'Camel',
			beige: 'Beige',
			'light-gray': 'Light gray',
			orange: 'Orange',
			'off-white': 'Off-white',
		},
	},
	'young-royal-shirt': {
		name: 'young-royal shirt',
		variations: {
			black: 'Black',
			pink: 'Pink',
			blue: 'Blue',
			cream: 'Cream',
			white: 'White',
		},
	},
	'zigzag-shirt': {
		name: 'zigzag shirt',
		variations: {
			na: 'NA',
		},
	},
};

export { _tops };
